"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/styles");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var styles_2 = __importDefault(require("./styles"));
var FormRadioGroup = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, overrideClasses = _a.overrideClasses;
    var _b;
    var useStyles = styles_1.makeStyles(styles_2.default(overrideClasses));
    var classes = useStyles({ fontSize: item.fontSize });
    var checkBoolean = function (value) {
        return value === "true" || value === "false" ? value === "true" : value;
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, item: true, alignItems: "center", spacing: 2 },
        (item === null || item === void 0 ? void 0 : item.label) && (react_1.default.createElement(Grid_1.default, { item: true, xs: "auto" },
            react_1.default.createElement(Typography_1.default, { className: classes.radioGroupHeader }, item.label))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: "auto" },
            react_1.default.createElement(RadioGroup_1.default, { id: item.idHtml || item.stateKey, key: item.stateKey, name: item.stateKey, value: fields
                    ? lodash_1.get(fields, item.stateKey, false)
                    : lodash_1.get(values, item.stateKey, false), onChange: function (e) {
                    if (typeof e.target.value)
                        if (setFieldValue)
                            setFieldValue(item.stateKey, checkBoolean(e.target.value));
                    if (changeField)
                        changeField({
                            key: item.stateKey,
                            value: Object(item).hasOwnProperty("id")
                                ? {
                                    id: item.id,
                                    value: checkBoolean(e.target.value),
                                }
                                : checkBoolean(e.target.value),
                        });
                }, row: !item.isRadioNotRow }, (_b = item === null || item === void 0 ? void 0 : item.radioGroupOptions) === null || _b === void 0 ? void 0 : _b.map(function (child, id) { return (react_1.default.createElement(FormControlLabel_1.default, { key: id, value: child.value, control: react_1.default.createElement(Radio_1.default, null), label: typeof child.label === "string" ? (react_1.default.createElement(Typography_1.default, { className: classes.radioLabel }, child.label)) : (child.label) })); })))));
};
exports.default = FormRadioGroup;
//# sourceMappingURL=GenericFormRadioGroup.js.map